import React, { useState } from "react";
import { useRouter } from "next/router";
import classNames from "classnames";
import Image from "next/image";
import CustomText from "@/components/ui/text/custom-text";
import useDynamicTranslation from "@/hooks/use-universal-transalation";
import nicdc_logo from "@/assets/images/nicdc_logo.png";
import g20_logo from "@/assets/images/g20_logo.png";
import azadi_logo from "@/assets/images/azadi_loog.jpg";
import swatcha_logo from "@/assets/images/swatcha_logo.jpg";
import Link from "next/link";
import cn from "@/hooks/class-names";
export const desktopNavClass = "laptop:text-[11px] laptop-large:text-[14px]";

const MenuItems = [
  { languageKey: "home", url: "/" },
  {
    languageKey: "About",
    url: "",
    hasChild: [
      { languageKey: "Overview", url: "/about/overview" },
      { languageKey: "Corporate Profile", url: "/about/corporate-profile" },
      { languageKey: "Our Journey", url: "/about/our-journey" },
      { languageKey: "Mission & Vision", url: "/about/mission-and-vision" },
      {
        languageKey: "Implementation Framework",
        url: "/about/implementation-framework",
      },
      {
        languageKey: "Leadership & Management",
        url: "/about/leadership-and-management",
      },
      { languageKey: "Board of Directors", url: "/about/board-of-directors" },
      {
        languageKey: "Right to Information",
        url: "/about/right-to-information",
      },
      {
        languageKey: "ISO Certification",
        url: "/assets/pdfs/ISO_Certificate-_NICDC.pdf",
        target: "_blank",
      },
      { languageKey: "Links", url: "/about/links" },
    ],
  },
  {
    languageKey: "Projects",
    url: "",
    hasChild: [
      {
        languageKey: "NICDC Corridor Development Programme",
        url: "/projects/national-industrial-corridor-development-programme",
      },
      {
        languageKey: "4 Projects Developed",
        // url: "/projects/4-projects-developed/dholera-special-investment-region-gujarat",
        hasChild: [
          {
            languageKey: "Dholera Special Investment Region, Gujarat",
            url: "/projects/4-projects-developed/dholera-special-investment-region-gujarat",
          },
          {
            languageKey: "Aurangabad Industrial City (AURIC), Maharashtra",
            url: "/projects/4-projects-developed/aurangabad-industrial-city-auric-maharashtra",
          },
          {
            languageKey: "Integrated Industrial Township, Greater Noida",
            url: "/projects/4-projects-developed/integrated-industrial-township-greater-noida",
          },
          {
            languageKey: "Integrated Industrial Township, Vikram Udyogpuri",
            url: "/projects/4-projects-developed/integrated-industrial-township-vikram-udyogpuri",
          },
        ],
      },
      {
        languageKey: "4 Projects Nearing Completion",
        // url: "/projects/4-projects-nearing-completion/tumakuru-industrial-area-karnataka",
        hasChild: [
          {
            languageKey: "Tumakuru Industrial Area, Karnataka",
            url: "/projects/4-projects-nearing-completion/tumakuru-industrial-area-karnataka",
          },
          {
            languageKey: "Krishnapatnam Industrial Area, Andhra Pradesh",
            url: "/projects/4-projects-nearing-completion/krishnapatnam-industrial-area-andhra-pradesh",
          },
          {
            languageKey:
              "Integrated Multi Modal Logistics Hub (IMLH), Nangal Chaudhary",
            url: "/projects/4-projects-nearing-completion/integrated-multi-modal-logistics-hub-nangal-chaudhary",
          },
          {
            languageKey:
              "Multi Modal Logistics Hub & Multi Modal Transport Hub, Dadri, Greater Noida, U.P.",
            url: "/projects/4-projects-nearing-completion/multi-modal-logistics-and-transport-hub-dadri-greater-noida-up",
          },
        ],
      },
      {
        languageKey: "12 New Projects",
        // url: "/projects/12-new-projects/imc-khurpia-uttarakhand",
        hasChild: [
          {
            languageKey: "IMC Khurpia, Uttarakhand",
            url: "/projects/12-new-projects/imc-khurpia-uttarakhand",
          },
          {
            languageKey: "IMC Rajpura Patiala, Punjab",
            url: "/projects/12-new-projects/imc-rajpura-patiala-punjab",
          },
          {
            languageKey: "IMC Hisar, Haryana",
            url: "/projects/12-new-projects/imc-hisar-haryana",
          },
          {
            languageKey: "IMC Agra, Uttar Pradesh",
            url: "/projects/12-new-projects/imc-agra-uttar-pradesh",
          },
          {
            languageKey: "IMC Prayagraj, Uttar Pradesh",
            url: "/projects/12-new-projects/imc-prayagraj-uttar-pradesh",
          },
          {
            languageKey: "IMC Gaya, Bihar",
            url: "/projects/12-new-projects/imc-gaya-bihar",
          },
          {
            languageKey: "Dighi Port Ind. Area, Maharashtra",
            url: "/projects/12-new-projects/dighi-port-ind-area-maharashtra",
          },
          {
            languageKey: "Jodhpur Pali Marwar, Rajasthan",
            url: "/projects/12-new-projects/jodhpur-pali-marwar-rajasthan",
          },
          {
            languageKey: "Kopparthy, Andhra Pradesh",
            url: "/projects/12-new-projects/kopparthy-andhra-pradesh",
          },
          {
            languageKey: "Orvakal, Andhra Pradesh",
            url: "/projects/12-new-projects/orvakal-andhra-pradesh",
          },
          {
            languageKey: "Zaheerabad, Telangana",
            url: "/projects/12-new-projects/zaheerabad-telangana",
          },
          {
            languageKey: "Palakkad, Kerala",
            url: "/projects/12-new-projects/palakkad-kerala",
          },
        ],
      },
    ],
  },
  { languageKey: "Tenders", url: "/tenders" },

  { languageKey: "Investors", url: "/investors" },

  {
    languageKey: "Media",
    url: "",
    hasChild: [
      // { languageKey: "News & Events", url: "/blog/series/news-and-events" },
      // { languageKey: "News & Events", url: "/nicdc-media/news-and-events" },
      {
        languageKey: "News & Events",
        url: "/nicdc-media/news-and-events",
        hasChild: [
          {
            languageKey: "Regional News",
            url: "/nicdc-media/news-and-events/regional-news",
          },
        ],
      },
      // { languageKey: "Articles", url: "/blog/series/articles" },
      { languageKey: "Articles", url: "/nicdc-media/articles" },
      { languageKey: "Video Gallery", url: "/nicdc-media/video-gallery" },
      { languageKey: "Gallery", url: "/nicdc-media/gallery" },
    ],
  },
  {
    languageKey: "Resources",
    url: "",
    hasChild: [
      {
        languageKey: "Corporate Brochure",
        url: "/resources/corporate-brochure",
      },
      {
        languageKey: "Meetings",
        url: "",
        hasChild: [
          {
            languageKey: "Annual General Meeting",
            url: "/resources/meetings/annual-general-meeting",
          },
          {
            languageKey: "Calendar of Meetings",
            url: "/resources/meetings/calendar-of-meeting",
          },
        ],
      },
      { languageKey: "Pitch Book", url: "/resources/pitch-book" },
      {
        languageKey: "Annual Reports",
        url: "",
        hasChild: [
          {
            languageKey: "Reports of NICDC",
            url: "/resources/annual-reports/reports-of-nicdc",
          },
          {
            languageKey: "Reports of NICDIT",
            url: "/resources/annual-reports/reports-of-nicdit",
          },
          {
            languageKey: "Reports of Subsidiary",
            url: "/resources/annual-reports/reports-of-subsidiary",
          },
        ],
      },
      { languageKey: "CSR Policies", url: "/resources/csr-policies" },
      {
        languageKey: "Environmental Clearances",
        url: "",
        hasChild: [
          {
            languageKey: "NICDC",
            url: "/resources/environmental-clearances/nicdc",
          },
        ],
      },
      {
        languageKey: "Employees Handbook",
        url: "/resources/employees-handbook",
      },
      { languageKey: "PoSH Act, 2013", url: "/resources/posh-act" },
      { languageKey: "SHE Complaint Box", url: "https://shebox.wcd.gov.in", target: "_blank", },
      { languageKey: "Land Allotment", url: "/resources/land-allotment" },
    ],
  },
  {
    languageKey: "Careers",
    url: "",
    hasChild: [
      { languageKey: "NICDC Openings", url: "/careers/nicdc-openings" },
      {
        languageKey: "NLDSL Openings",
        url: "https://nldsl.in/current_opening.aspx?mpgid=36&pgidtrail=68",
        target: "_blank",
      },
      {
        languageKey: "IICC Openings",
        url: "https://iiccl.dpiit.gov.in/careers",
        target: "_blank",
      },
      {
        languageKey: "IITGNL Openings",
        url: "https://www.iitgnl.com/gnl-currentOpenings",
        target: "_blank",
      },
    ],
  },
  { languageKey: "Contact Us", url: "/contact" },
];

function Navbar() {
  const { getTranslated } = useDynamicTranslation(["navbar"]);
  const router = useRouter();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const handleAnimation = () => {
    const menuButton = document.querySelector(".menu");
    menuButton.classList.toggle("opened");
    menuButton.setAttribute(
      "aria-expanded",
      menuButton.classList.contains("opened")
    );
    setMobileNavOpen((prev) => !prev);
  };

  const MobileNavLinks = ({ open }) => {
    const { getTranslated } = useDynamicTranslation("navbar");
    const [openMenus, setOpenMenus] = useState({
      firstLevel: null,
      secondLevel: null,
      thirdLevel: null,
    });

    const handleFirstLevelClick = (index) => {
      setOpenMenus((prev) => ({
        firstLevel: prev.firstLevel === index ? null : index,
        secondLevel: null,
        thirdLevel: null,
      }));
    };

    const handleSecondLevelClick = (firstIndex, secondIndex) => {
      setOpenMenus((prev) => ({
        firstLevel: firstIndex,
        secondLevel: prev.secondLevel === secondIndex ? null : secondIndex,
        thirdLevel: null,
      }));
    };

    const handleThirdLevelClick = (firstIndex, secondIndex, thirdIndex) => {
      setOpenMenus((prev) => ({
        firstLevel: firstIndex,
        secondLevel: secondIndex,
        thirdLevel: prev.thirdLevel === thirdIndex ? null : thirdIndex,
      }));
    };

    const DropdownArrow = ({ isOpen }) => (
      <span
        className={classNames("transition-transform duration-200", {
          "-rotate-180": isOpen,
        })}
      >
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </span>
    );

    return (
      <div
        aria-label="mobile navigation"
        className={classNames("mobile-nav-wrapper", { open })}
      >
        <div className="w-full h-full max-h-screen overflow-y-auto">
          <ul className="w-full uppercase">
            {MenuItems.map((menu, index) => (
              <div key={index} className="w-full">
                <div className="flex items-center p-3 w-full uppercase text-sm font-bold tracking-wide transition hover:border-t-2 hover:border-t-primary">
                  {/* Main link - always clickable */}
                  <a
                    href={menu.url || "#"}
                    className="flex-1 flex items-center"
                    onClick={(e) => {
                      // If there's no URL and it has children, prevent default
                      if (!menu.url && menu.hasChild) {
                        e.preventDefault();
                      }
                    }}
                  >
                    <span className="pr-1 font-semibold flex-1">
                      <CustomText
                        text={getTranslated(
                          menu.languageKey.toLowerCase(),
                          "navbar"
                        )}
                        className="xl:text-xs 2xl:text-sm uppercase"
                      />
                    </span>
                  </a>

                  {/* Dropdown toggle button - separate from the link */}
                  {menu.hasChild && (
                    <button
                      aria-haspopup="true"
                      className="px-2 py-1"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleFirstLevelClick(index);
                      }}
                    >
                      <DropdownArrow isOpen={openMenus.firstLevel === index} />
                    </button>
                  )}
                </div>

                {menu.hasChild && (
                  <div
                    className={classNames(
                      "w-full bg-white overflow-hidden transition-all duration-200",
                      {
                        "h-auto max-h-80 overflow-y-auto":
                          openMenus.firstLevel === index,
                        "h-0": openMenus.firstLevel !== index,
                      }
                    )}
                  >
                    {menu.hasChild.map((child, childIndex) => (
                      <div key={childIndex} className="w-full">
                        <div className="flex items-center w-full">
                          <a
                            target={child?.target || "_self"}
                            href={child.url || "#"}
                            className="flex-1 px-6 py-2 hover:bg-orange hover:text-white"
                            onClick={(e) => {
                              if (!child.url && child.hasChild) {
                                e.preventDefault();
                              }
                            }}
                          >
                            <CustomText
                              text={getTranslated(
                                child.languageKey.toLowerCase(),
                                "navbar"
                              )}
                              className="xl:text-xs 2xl:text-sm"
                            />
                          </a>
                          {child.hasChild && (
                            <button
                              className="px-4 py-2"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleSecondLevelClick(index, childIndex);
                              }}
                            >
                              <DropdownArrow
                                isOpen={openMenus.secondLevel === childIndex}
                              />
                            </button>
                          )}
                        </div>
                        {child.hasChild && (
                          <div
                            className={classNames(
                              "w-full bg-gray-50 overflow-hidden transition-all duration-200",
                              {
                                "h-auto max-h-64 overflow-y-auto":
                                  openMenus.secondLevel === childIndex,
                                "h-0": openMenus.secondLevel !== childIndex,
                              }
                            )}
                          >
                            {child.hasChild.map((subChild, subChildIndex) => (
                              <div key={subChildIndex} className="w-full">
                                <div className="flex items-center w-full">
                                  <a
                                    href={subChild.url || "#"}
                                    className="flex-1 px-8 py-2 hover:bg-orange hover:text-white"
                                    onClick={(e) => {
                                      if (!subChild.url && subChild.hasChild) {
                                        e.preventDefault();
                                      }
                                    }}
                                  >
                                    <CustomText
                                      text={getTranslated(
                                        subChild.languageKey.toLowerCase(),
                                        "navbar"
                                      )}
                                      className="xl:text-xs 2xl:text-sm"
                                    />
                                  </a>
                                  {subChild.hasChild && (
                                    <button
                                      className="px-4 py-2"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleThirdLevelClick(
                                          index,
                                          childIndex,
                                          subChildIndex
                                        );
                                      }}
                                    >
                                      <DropdownArrow
                                        isOpen={
                                          openMenus.thirdLevel === subChildIndex
                                        }
                                      />
                                    </button>
                                  )}
                                </div>
                                {subChild.hasChild && (
                                  <div
                                    className={classNames(
                                      "w-full bg-gray-100 overflow-hidden transition-all duration-200",
                                      {
                                        "h-auto max-h-48 overflow-y-auto":
                                          openMenus.thirdLevel === subChildIndex,
                                        "h-0":
                                          openMenus.thirdLevel !== subChildIndex,
                                      }
                                    )}
                                  >
                                    {subChild.hasChild.map(
                                      (grandChild, grandChildIndex) => (
                                        <div
                                          key={grandChildIndex}
                                          className="w-full"
                                        >
                                          <a
                                            href={grandChild.url || "#"}
                                            className="block px-10 py-2 hover:bg-orange hover:text-white"
                                          >
                                            <CustomText
                                              text={getTranslated(
                                                grandChild.languageKey.toLowerCase(),
                                                "navbar"
                                              )}
                                              className="xl:text-xs 2xl:text-sm"
                                            />
                                          </a>
                                        </div>
                                      )
                                    )}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  const DesktopNavLinks = () => (
    <ul className="hidden laptop:flex laptop:gap-3 laptop-large:flex laptop-large:gap-6 uppercase text-sm font-semibold">
      {MenuItems.map((menu, index) => (
        <div key={index} className="group inline-block relative">
          <button
            aria-haspopup="true"
            className="flex items-center uppercase transition hover:border-t-2 hover:border-t-orange "
          >

            <a href={(menu.url && menu.url) || "#"} className="cursor-pointer">
              <span className="pr-1 flex-1 cursor-pointer whitespace-nowrap">
                <CustomText
                  text={getTranslated(menu.languageKey.toLowerCase(), "navbar")}
                  className={cn(desktopNavClass, "cursor-pointer")}
                />
              </span>
            </a>
            {menu.hasChild && (
              <span>
                <svg
                  className="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-150 ease-in-out"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  {" "}
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />{" "}
                </svg>
              </span>
            )}
          </button>
          {/* First-level children */}
          {menu.hasChild && (
            <ul className="bg-white text-black rounded-sm absolute top-full left-0 hidden group-hover:block min-w-[200px] shadow-md z-30">
              {menu.hasChild.map((child, childIndex) => (
                <li
                  key={childIndex}
                  className={`group/child hover:bg-gray-100 text-gray-700 cursor-pointer ${child.hasChild ? "relative" : ""
                    }`}
                >
                  <a
                    href={(child.url && child.url) || "#"}
                    className="block px-4 py-2 cursor-pointer hover:bg-orange hover:text-white hover:font-bold "
                    target={child?.target ? "_blank" : "_self"}
                  >
                    <CustomText
                      text={getTranslated(
                        child.languageKey.toLowerCase(),
                        "navbar"
                      )}
                      className={cn(desktopNavClass, "cursor-pointer ")}
                    />
                  </a>
                  {child.hasChild && (
                    <div
                      className="absolute top-0 right-full hidden group-hover/child:block"
                      style={{ marginRight: "1px" }}
                    >
                      <ul className="bg-white rounded-sm min-w-[200px] shadow-md z-40">
                        {child.hasChild.map((subChild, subChildIndex) => (
                          <li
                            key={subChildIndex}
                            className="px-4 py-2 whitespace-pre-line hover:bg-orange hover:text-white hover:font-bold"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (subChild.url)
                                window.location.href = subChild.url;
                            }}
                          >
                            <a
                              target="_blank"
                              href={subChild.url || "#"}
                              className="whitespace-pre-line"
                            >
                              <CustomText
                                text={getTranslated(
                                  subChild.languageKey.toLowerCase(),
                                  "navbar"
                                )}
                                className={cn(desktopNavClass, "cursor-pointer")}
                              />
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </ul>
  );

  return (
    <div
      className={cn(
        "flex justify-between py-3 px-2 laptop:px-10 laptop-large:px-20 items-center bg-white"
      )}
    >
      {/* Logos */}
      <div className="flex gap-2 items-center">
        <Link href="/">
          <Image
            src={nicdc_logo}
            className=" w-[50px] h-[80px] laptop:w-[50px] laptop:h-[70px] laptop-large:h-full laptop-large:w-[60px]"
            alt="NICDC Logo"
          />
        </Link>
        <Link href="https://swachhbharatmission.ddws.gov.in/" target="_blank">
          <Image
            src={swatcha_logo}
            className=" w-[70px] h-[50%] laptop:w-[50px] laptop:h-[full]  laptop-large:h-full laptop-large:w-[100px]"
            alt="Swachhta Logo"
          />
        </Link>
      </div>
      {/* Desktop Links */}
      <DesktopNavLinks />

      {/* Mobile Menu */}
      <div className="laptop:hidden">
        <button
          className="menu"
          onClick={() => handleAnimation()}
          aria-label="Main Menu"
        >
          <svg width="50" height="50" viewBox="0 0 100 100">
            <path
              className="line line1"
              d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
            />
            <path className="line line2" d="M 20,50 H 80" />
            <path
              className="line line3"
              d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
            />
          </svg>
        </button>
        <MobileNavLinks open={mobileNavOpen} />
      </div>
    </div>
  );
}

export default Navbar;